module.exports = __webpack_public_path__ + "img/i_menu.3b5fd561.svg";